export default {
	// Custom Page Meta
	seo_meta_title_leaguepass: 'League Pass - Strim Perlawanan NBA Secara Langsung | NBA.com',
	seo_meta_desc_leaguepass: 'Strim perlawanan NBA secara langsung dan atas permintaan dengan League Pass. Akses akaun anda di sini.',
	seo_meta_keywords_leaguepass: 'Video NBA, Sorotan NBA, Video Bola Keranjang, perlawanan penting, dunk, ciri-ciri',
	seo_meta_title_featured: 'Strim Perlawanan NBA & Tonton Sorotan | NBA.com',
	seo_meta_desc_featured: 'Tonton video sorotan NBA, berita dan analisis secara percuma. Terokai juga langganan NBA TV & League Pass untuk menonton perlawanan secara langsung pada peranti kegemaran anda.',
	seo_meta_keywords_featured: '',
	seo_meta_title_nbatv: 'NBA TV - Strim Perlawanan Secara Langsung Dan Liputan 24-7 | NBA.com',
	seo_meta_desc_nbatv: 'Strim perlawanan NBA TV secara langsung atau tonton perlawanan klasik yang ikonik. Selain itu, dapatkan akses ke rancangan studio dan analisis daripada seluruh liga.',
	seo_meta_keywords_nbatv: 'Saluran NBA TV, rentak perlawanan, program Hardwood Classics, NBA siaran langsung, program NBA Gametime, tinjauan fantasi, rancangan studio, program the Jump',
	seo_meta_title_classicgames: 'Strim Perlawanan Klasik dengan NBA TV & Banyak Lagi | NBA.com',
	seo_meta_desc_classicgames: 'Strim pertandingan NBA yang ikonik dengan NBA TV. Strim juga perlawanan NBA TV secara langsung dan dapatkan akses ke rancangan studio dan analisis daripada seluruh liga.',
	seo_meta_keywords_classicgames: '',
	seo_meta_pre_title_videolist: 'Strim Kandungan Di Sini | NBA.com',
	seo_meta_title_videolist: 'Strim {0} Di Sini | NBA.com',
	seo_meta_desc_videolist: 'Tonton {0} video di sini. Terokai juga langganan NBA TV & League Pass untuk menonton siaran langsung pada peranti kegemaran anda.',
	seo_meta_title_videolist_show: 'Strim {0} dengan NBA TV | NBA.com',
	seo_meta_desc_videolist_show: 'Tonton {0} di sini. Strim juga perlawanan NBA TV secara langsung dan dapatkan akses ke perlawanan dan analisis klasik.',
	seo_meta_keywords_videolist_show: '',
	seo_meta_title_videolist_feed: 'Strim {0} Di Sini | NBA.com',
	seo_meta_desc_videolist_feed: 'Tonton {0} video di sini. Terokai juga langganan NBA TV & League Pass untuk menonton siaran langsung pada peranti kegemaran anda.',
	seo_meta_keywords_videolist_feed: '',
	seo_meta_keywords_videolist: '',
	seo_meta_title_shows: 'Strim Rancangan Studio dengan NBA TV & Banyak Lagi | NBA.com',
	seo_meta_desc_shows: 'Terokai dan strim Rancangan dan Episod NBA TV terkini secara atas permintaan. Strim juga perlawanan NBA TV secara langsung dan dapatkan akses ke perlawanan dan analisis klasik.',
	seo_meta_keywords_shows: '',
	// Common Page Meta
	seo_meta_title_home: 'Utama | NBA.com',
	seo_meta_desc_home: '',
	seo_meta_keywords_home: '',
	seo_meta_title_channels: 'Saluran | NBA.com',
	seo_meta_desc_channels: '',
	seo_meta_keywords_channels: '',
	seo_meta_pre_title_channel: 'Saluran | NBA.com',
	seo_meta_pre_title_categories: 'Kategori | NBA.com',
	seo_meta_title_categories: 'Kategori | NBA.com',
	seo_meta_desc_categories: '',
	seo_meta_keywords_categories: '',
	seo_meta_pre_title_category: 'Kategori | NBA.com',
	seo_meta_title_category: 'Kategori | NBA.com',
	seo_meta_desc_category: '',
	seo_meta_keywords_category: '',
	seo_meta_pre_title_video: 'Strim Video Di Sini | NBA.com',
	seo_meta_pre_title_event: 'Strim Acara Di Sini | NBA.com',
	seo_meta_title_events: 'Acara | NBA.com',
	seo_meta_desc_events: '',
	seo_meta_keywords_events: '',
	seo_meta_title_event: 'Strim {0} Di Sini | NBA.com',
	seo_meta_desc_event: 'Tonton {0} di sini. Terokai juga langganan NBA TV & League Pass untuk menonton perlawanan secara langsung pada peranti kegemaran anda.',
	seo_meta_keywords_event: '',
	seo_meta_title_search: 'Cari | NBA.com',
	seo_meta_desc_search: '',
	seo_meta_keywords_search: '',
	seo_meta_title_notfound: 'Laman Tidak Ditemui | NBA.com',
	seo_meta_desc_notfound: '',
	seo_meta_keywords_notfound: '',
	seo_meta_pre_title_game: 'Strim Perlawanan Di Sini | NBA.com',
	seo_meta_title_game: 'Strim {0} Di Sini | NBA.com',
	seo_meta_desc_game: 'Tonton {0} di sini. Terokai juga langganan NBA TV & League Pass untuk menonton siaran langsung pada peranti kegemaran anda.',
	seo_meta_keywords_game: '',
	seo_meta_title_video: 'Strim {0} Di Sini | NBA.com',
	seo_meta_desc_video: 'Tonton {0} di sini. Terokai juga langganan NBA TV & League Pass untuk menonton siaran langsung pada peranti kegemaran anda.',
	seo_meta_keywords_video: 'Video NBA, Sorotan NBA, Video Bola Keranjang, perlawanan penting, dunk, ciri-ciri',
	seo_meta_title_episode: 'Strim {0} dengan NBA TV | NBA.com',
	seo_meta_desc_episode: 'Tonton {0} di sini. Strim juga perlawanan NBA TV secara langsung dan dapatkan akses ke perlawanan dan analisis klasik.',
	seo_meta_keywords_episode: 'Video NBA, Sorotan NBA, Video Bola Keranjang, perlawanan penting, dunk, ciri-ciri',
	seo_meta_title_channel: 'NBA TV Secara Langsung | NBA.com',
	seo_meta_desc_channel: 'NBA TV Siaran Langsung membawakan anda saluran NBA TV 24 jam sehari dengan penstriman perlawanan NBA secara langsung dan dari arkib setiap minggu, jadual program Studio dan liputan penganalisis',
	seo_meta_keywords_channel: 'Saluran NBA TV, rentak perlawanan, program Hardwood Classics, NBA siaran langsung, program NBA Gametime, tinjauan fantasi, rancangan studio, program the Jump',
	seo_meta_title_tvguide: 'Jadual Strim Secara Langsung NBA TV | NBA.com',
	seo_meta_desc_tvguide: 'Ketahui waktu perlawanan dan rancangan studio secara langsung di NBA TV yang boleh distrim pada peranti kegemaran anda. Dapatkan juga akses ke rancangan studio dan analisis atas permintaan.',
	seo_meta_keywords_tvguide: 'Saluran NBA TV, rentak perlawanan, program Hardwood Classics, NBA siaran langsung, program NBA Gametime, tinjauan fantasi, rancangan studio, program the Jump',

	// Common
	timezone: 'ET',
	default_feed_error_message: 'Ada yang tidak kena, kandungan tidak tersedia sekarang. Anda boleh cuba semula.',
	watch_in_app: 'TONTON DI APLIKASI NBA',
	ad_blocked_message: 'Penyekat Iklan Dikesan: Kandungan NBA.com disokong oleh iklan. Untuk terus menikmati kandungan kami, sila tutup penyekat iklan anda.',

	// Item
	no_content: 'Tiada Kandungan',
	see_more: 'Lihat Lagi',
	now_playing: 'KINI DITAYANGKAN',
	nba_tv_lock: 'NBA TV',
	league_pass_lock: 'League Pass',
	league_pass_premium_lock: 'PREMIUM LP',
	error_max_limit_favorite: 'Anda telah mencapai bilangan maksimum bagi video kegemaran. Buang beberapa video kegemaran sebelum menambah lagi.',
	item_live: 'Langsung',
	add_favourite_title: 'TAMBAH KE FAVORITE',
	remove_favourite_title: 'KELUARKAN DARI FAVORITE',
	// Channel: Schedule
	p_channel_live: 'Langsung',
	p_channel_schedule_title: 'Jadual NBA TV',
	p_channel_schedule_watch: 'Tonton',
	p_channel_live24x7_title: 'NBA TV 24/7',
	p_channel_live24x7_see_full_schedule: 'Lihat Jadual Penuh',
	p_channel_live24x7_up_next: 'seterusnya',
	p_channel_live24x7_on_demand: 'NBA TV: Atas Permintaan',
	p_channel_live24x7_collection: 'Koleksi',
	p_channel_live24x7_demand_1_logo_text: 'rancangan asli',
	p_channel_live24x7_demand_1_show_name: 'Rancangan NBA TV',
	p_channel_live24x7_demand_1_show_desc: 'Rancangan NBA TV yang asli termasuk Shaqtin \'a Fool, Beyond the Paint, Game Time dan Basketball Stories',
	p_channel_live24x7_demand_2_logo_text: 'Perlawanan klasik',
	p_channel_live24x7_demand_2_show_name: 'NBA | Perlawanan Klasik',
	p_channel_live24x7_demand_2_show_desc: 'Tonton Perlawanan Klasik yang penuh, termasuk semua pertandingan akhir sejak tahun 2000, detik-detik bersejarah liga dan pemain legenda',

	// Channel: Clips
	p_channel_error_msg: 'Belum tersedia lagi',

	// Channel: detail
	p_channel_category_title: 'NBA TV',
	p_channel_playlist_title: 'Jadual',

	// NBA TV Shows:
	p_nba_tv_shows: 'Rancangan NBA TV',
	p_nba_tv_no_access_title: '24/7 NBA: Dapatkan maklumat terkini analisis perlawanan, analisis studio, rancangan asli, dan banyak lagi!',
	p_nba_tv_no_access_desc: 'Tonton perlawanan secara langsung serta rancangan dan perlawanan klasik atas permintaan.',
	p_nba_tv_no_access_note: 'Tertakluk kepada sekatan',

	// tv show item
	tv_show_item_latest_episode: 'episod terkini',
	tv_show_item_no_latest_episode: 'tiada episod terkini',
	see_all: 'Lihat Semua',
	// header
	header_menu_watch: 'Tonton',
	header_menu_featured: 'SOROTAN',
	header_menu_nba_tv: 'NBA TV',
	header_menu_league_pass: 'League Pass',

	// search
	players: 'Pemain',
	videos: 'Video',
	teams: 'Pasukan',
	most_searched: 'PALING BANYAK DICARI',
	no_result: 'Tiada Data',
	searchfilter_type_most_relevant: 'Paling relevan',
	searchfilter_type_most_viewed: 'Paling banyak ditonton',
	searchfilter_type_most_recent: 'Yang terkini',
	searchfilter_type_last_30_days: '30 hari terakhir',
	searchfilter_type_last_6_months: '6 bulan terakhir',
	searchresult_label: 'Hasil carian untuk \'{keyword}\'',
	searchresult_info: 'Lihat semua hasil carian untuk {keyword}',
	searchplaceholder: 'Cari di pustaka video',
	load_more: 'Memuatkan Lagi...',

	// button
	button_subscribe: 'Melanggan',
	button_sign_in: 'Log Masuk',
	button_tv_provider: 'Pilih Penyedia TV',

	// league page
	p_league_pass_no_access_title: 'Tonton perlawanan secara langsung atau ulangan di mana-mana peranti, termasuk komputer, telefon pintar dan TV anda!',
	p_league_pass_no_access_desc: 'Tiket untuk aksi terkini: tonton kesemua liga atau pasukan kegemaran anda, pilih perlawanan tunggal, atau lihat pilihan-pilihan lain.',
	p_league_pass_no_access_note: 'Tertakluk kepada terma',

	// Video
	category_title: 'Video',
	p_video_playlist_title: 'Senarai main',
	p_video_episode_text: 'Episod',
	p_no_access_league_pass_title: 'Buka NBA League Pass untuk menonton:',
	p_no_access_league_pass_premium_title: 'Unlock NBA League Pass Premium to watch:',
	p_no_access_league_pass_desc: 'Tiket untuk aksi terkini: tonton kesemua liga atau pasukan kegemaran anda, pilih perlawanan tunggal, atau lihat pilihan-pilihan lain.',
	p_no_access_league_pass_terms: 'Tertakluk kepada terma',
	p_no_access_league_pass_geo_desc: 'Berdasarkan lokasi semasa, anda tidak dapat menonton perlawanan ini melalui NBA League Pass dan NBA TV. Arkib perlawanan ini akan tersedia 3 hari selepas disiarkan untuk pelanggan NBA League Pass. Sila rujuk jadual siaran TV dan radio tempatan untuk mengetahui siaran di kawasan anda.',
	p_no_access_league_pass_not_found_desc: 'Maaf, video yang anda cari tidak ditemui.',
	p_no_access_event_geo_desc: 'Siaran ini tidak tersedia untuk peminat di Amerika Syarikat atau Kanada. Untuk menonton, sila ikuti ESPN di AS, dan TSN atau Sportsnet di Kanada.',
	p_no_access_event_not_found_desc: 'Maaf, acara yang anda cari tidak ditemui.',
	p_no_access_nba_tv_title: 'Buka NBA TV untuk menonton:',
	p_no_access_nba_tv_desc: 'Tonton perlawanan secara langsung serta rancangan dan permainan klasik atas permintaan.',
	p_no_access_nba_tv_terms: 'Tertakluk kepada terma',
	p_no_access_nba_tv_geo_desc: 'Berdasarkan lokasi semasa, anda tidak dapat menonton perlawanan ini melalui NBA League Pass dan NBA TV. Arkib perlawanan ini akan tersedia 3 hari selepas disiarkan untuk pelanggan NBA League Pass. Sila rujuk jadual siaran TV dan radio tempatan untuk mengetahui siaran di kawasan anda.',
	p_no_access_nba_tv_not_found_desc: 'Maaf, saluran yang anda cari tidak ditemui.',
	p_no_access_up_next: 'Seterusnya:',
	p_video_completed_title: 'Senarai Main Lengkap',
	p_video_completed_desc: 'Kembali melayar atau lihat senarai main seterusnya untuk anda',
	p_video_share_to: 'Kongsi ke:',
	p_video_more_to_watch: 'Lebih banyak untuk Ditonton:',

	// Event
	p_event_section_title: 'Acara',
	p_event_playlist_title: 'Senarai main',
	p_event_button_watch: 'Tonton',
	p_event_button_listen: 'Dengar',
	p_event_button_ticket: 'Tiket',

	// notfound page
	notfound: 'Maaf, halaman yang anda minta tidak dijumpai.',
	notfound_desc: 'Sila semak URL untuk kesilapan.<br/> Anda juga boleh cuba menggunakan navigasi tapak atau alat carian untuk mencari kandungan anda.',

	// Modal - PCM
	modal_pcm_header_title: '',
	modal_pcm_body_title: '',
	modal_pcm_body_description: 'Akaun NBA League Pass anda telah mencapai bilangan penstriman maksimum. Klik \'Teruskan\' untuk terus menonton dengan peranti ini.',
	modal_pcm_custom: 'Teruskan',
	modal_pcm_close: 'Batal',
	modal_pcm_ok: 'OK',

	// Modal - Unsupported
	modal_video_unsupported_header_title: '',
	modal_video_unsupported_body_title: '',
	modal_video_unsupported_body_description: 'Video ini tidak boleh dimainkan pada peranti anda. Klik <a href=\'https://neulion-a.akamaihd.net/nlweb/h5support/player.html\' target=\'_blank\'>DI SINI</a> untuk bantuan lanjut.',
	modal_video_unsupported_custom: '',
	modal_video_unsupported_close: 'OK',
	modal_video_unsupported_ok: 'OK',

	// FreeSample
	freesample_notice_time: 'Masa yang tinggal',
	freesample_notice_title: 'Nikmati Akses {0} Minit Anda',
	freesample_notice_desc: 'Langgan pakej penuh League Pass untuk terus mengakses kandungan selepas {0} minit anda tamat.',
	freesample_notice_subscribe_button: 'Melanggan',
	freesample_notice_cancel_button: 'BATALKAN PADA BILA-BILA MASA',
	freesample_popup_title: 'AKSES ANDA TELAH TAMAT',
	freesample_popup_subtitle: 'Langgan League Pass untuk menonton lebih banyak kandungan hebat NBA.',
	freesample_popup_link: 'KETAHUI LEBIH LANJUT!',
	freesample_popup_get_minutes_button: 'DAPATKAN {0}  MINIT',

	// Video list
	reg_required_desc: 'Anda perlu log masuk untuk melihat kandungan ini',
	favorite_teams_title: 'Pasukan Kegemaran',
	bookmarked_title: 'Disimpan',
	watch_history_title: 'Teruskan Menonton',
	game_schedule_title: 'Jadual Perlawanan',
	recommended_title: 'Disyorkan',
	season_text: 'Musim',

	// profile page
	section_information_title: 'Maklumat Saya',
	section_information_desc: 'Kemas kini maklumat peribadi anda',
	section_information_email: 'E-mel',
	section_information_email_update: 'Kemas kini Alamat E-mel',
	section_information_password: 'Kata Laluan',
	section_information_password_update: 'Tukar Kata Laluan',
	section_information_social: 'Rangkaian Sosial',
	section_information_nosocial_message: 'Anda tiada akaun yang bersambung.',
	section_information_firstname: 'Nama Pertama',
	section_information_lastname: 'Nama Akhir',
	section_information_birth: 'Tarikh Lahir',
	section_information_country: 'Negara/Wilayah',
	section_information_postalcode: 'Poskod',
	section_information_edit: 'Edit',
	section_tv_provider_title: 'Penyedia TV Saya',
	section_tv_provider_desc: 'Dapatkan akses ke perlawanan dan strim secara langsung oleh penyedia tv anda.',
	section_tv_provider_faq: 'Soalan Lazim Penyedia TV',
	section_tv_provider_sign_out: 'Log Keluar',
	section_tv_provider_sign_in: 'Log Masuk Penyedia TV',
	section_fantasy_title: 'Fantasi',
	section_fantasy_desc: 'Lihat maklumat akaun fantasi anda',
	section_fantasy_displayname: 'Nama Paparan',
	section_marketing_title: 'Keutamaan E-mel',
	section_marketing_desc: 'Lihat komunikasi pemasaran dan keutamaan privasi pengguna anda',
	section_marketing_newsletters: 'Surat berita',
	section_marketing_message: 'Pesanan dan Iklan NBA',
	section_marketing_newsletters_desc_1: 'Berita NBA dihantar setiap hari ke peti e-mel anda',
	section_marketing_newsletters_desc_2: 'Berita dan Paparan NBA G League daripada liga muda NBA yang rasmi',
	section_marketing_newsletters_desc_3: 'Berita dan kandungan Jr. NBA daripada inisiatif bola keranjang belia NBA',
	section_marketing_newsletters_desc_4: 'Ciri terkini dalam aplikasi NBA, termasuk kemas kini dan tawaran League Pass',
	section_marketing_newsletters_desc_5: 'Tawaran istimewa bagi tiket, tawaran rakan sekutu, serta diskaun bagi acara dan cenderamata daripada NBA',
	section_marketing_newsletters_desc_6: 'Berita dan kandungan NBA yang dipilih khas dan dihantar setiap minggu ke peti e-mel anda',
	section_marketing_newsletters_desc_7: 'Berita dan tawaran daripada WNBA dan rakan sekutunya.',
	section_marketing_personal_title: 'Maklumat Peribadi Saya',
	section_marketing_personal_desc: 'Sila gunakan maklumat peribadi saya untuk NBA menghantar mesej dan iklan mengenai produk dan inisiatif NBA serta rakan niaga NBA.',
	section_marketing_update_button: 'Kemas kini Keutamaan Pemasaran',
	section_marketing_update_success: 'Keutamaan anda telah berjaya dikemas kini.',
	section_ccpa_title: 'Jangan Jual Maklumat Peribadi Saya',

	// profile edit modal
	email_modal_title: 'kemas kini alamat e-mel',
	email_modal_new_email_label: 'alamat e-mel baharu',
	email_modal_update: 'Kemas kini',
	email_modal_cancel: 'Batal',
	password_modal_title: 'Tukar Kata Laluan',
	password_modal_current_label: 'Kata laluan semasa:',
	password_modal_new_label: 'Kata laluan baharu:',
	password_modal_confirm_label: 'Sahkan Kata Laluan',
	password_modal_update: 'Kemas kini',
	password_modal_cancel: 'Batal',
	personal_modal_title: 'kemas kini maklumat peribadi',
	personal_modal_email: 'E-mel',
	personal_modal_password: 'Kata Laluan',
	personal_modal_birth: 'Tarikh Lahir',
	personal_modal_social: 'rangkaian sosial',
	personal_modal_firstname: 'Nama Pertama',
	personal_modal_lastname: 'Nama Akhir',
	personal_modal_country: 'Negara/Wilayah',
	personal_modal_postalcode: 'Poskod',
	personal_modal_zipcode: 'poskod',
	personal_modal_postalcode_invalid_message: 'perlu poskod yang sah',
	personal_modal_zipcode_invalid_message: 'perlu poskod yang sah',
	personal_modal_update: 'Kemas kini',
	personal_modal_cancel: 'Batal',

	// payflow
	payflow_profile_name: 'Nama',
	payflow_profile_email: 'E-mel',

	// account page
	header_menu_account_my_account: 'Akaun Saya',
	header_menu_account_manage_account: 'Urus Akaun',
	header_menu_account_favorite_teams: 'Pasukan Kegemaran',
	header_menu_account_favorite_players: 'Pemain Kegemaran',
	header_menu_account_viewing_history: 'Sejarah Tontonan',
};
